import { Button, Input } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import InputField from "~components/Form/components/InputField";
import Select from "~components/Form/components/Select";
import Modal from "~components/Modal";
import useFunilObraGrupoProduto from "~fetchs/useFunilObraGrupoProduto";
import * as yup from 'yup';
import useFunilObraJustificativa from "~fetchs/useFunilObraJustificativa";

const FunnelVolumeUpdateModal = ({ isOpen, setIsOpen, submitHandler, values }) => {
  const formikRef = useRef();  
  const { funilObraGrupoProdutoObjeto } = useFunilObraGrupoProduto({});
  const { funilObraJustificativaSelect, optionFunilObraJustificativas, SetSelectFunilObraJustificativa, onChangeFunilObraJustificativa  } = useFunilObraJustificativa({ formikRef })
  const [hook, setHook] = useState(0);
  const [initialValues, setInitialValues] = useState({
    list: [{
      grupoProduto: "",
      volume: 0,
      volumeTotal: 10
    }],
    single: {
      funilObraJustificativaId: ""
    }
  });

  useEffect(() => {
    if(isOpen){
      setInitialValues({
        list: values.map(({funilObraGrupoProdutoId, etapa, id, volumeSkus, volumeGrupo}) => {
          const grupo = funilObraGrupoProdutoObjeto[`id-${funilObraGrupoProdutoId}`]?.nome ?? "Não Encontrado";
          return {
            id,
            grupoProduto: grupo,
            etapa,
            volume: volumeSkus,
            volumeTotal: volumeGrupo
          }
        }),
        single: {
          funilObraJustificativaId: ""
        }
      });
      setHook((prev) => prev + 1);
    }
  }, [isOpen]);

  const getFormValues = (e) => {
    let id = null;
    let obj = {
      list: [],
      single: {}
    };
    for(const[key, value] of Object.entries(e)) {
      const splited = key.split('-');
      if(splited.length == 2){
        if(!id) id = splited?.[1] ?? null;
        obj.list[splited[1]] ??= [];
        obj.list[splited[1]][splited[0]] = value;
      }else{
        obj.single[key] = value;
      }
    }

    return {
      id,
      obj
    }
  }

  let validation = yup.object({
    ...(values?.reduce((acc, cur) => {
      acc[`volumeTotal-${cur.id}`] = yup.number().required("O volume estimativo é obrigatório");
      return acc;
    }, {})),
    volumeValidacao: yup.array()
    .test({
        name:"volumeValidacao",
        test: function(values, context){
          if(context?.parent){
            const {id, obj} = getFormValues(context.parent);
            let groups = [];
            const single = obj.single;

            for(const [key, value] of Object.entries(obj.list)) {
              if(value.volume < value.volumeTotal) {
                groups.push(`${value.grupoProduto} - ${value.etapa}`);
              }              
            }

            if(groups.length > 0 && (!single.funilObraJustificativaId || single.funilObraJustificativaId == "")){
                throw this.createError({ message: `Há uma diferença entre o volume total dos grupos e seus SKUS correspondentes. 
                  São esses grupos:\n ${groups.join("\n")}\nAltere os valores ou selecione uma justificativa.`, path: this.path });
            }

          }

          return true;
        }
    })
  }
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      hideButtonTwo={true}
      hideButtonOne={true}
      sub={
        <Content 
          submitHandler={submitHandler} 
          initialValues={initialValues} 
          validation={validation} 
          hook={hook} 
          getFormValues={getFormValues}
          formikRef={formikRef}
          funilObraJustificativa={{
            funilObraJustificativaSelect,
            optionFunilObraJustificativas,
            SetSelectFunilObraJustificativa,
            onChangeFunilObraJustificativa
          }}
        />
      }
    />
  );
};

const Content = ({ submitHandler, validation, initialValues, hook, getFormValues, formikRef, funilObraJustificativa }) => {
  return (
    <div>
      <h2 className="font-bold text-xl mx-auto max-w-[400px]">
        Há uma diferença de entre o volume total do grupo e os SKUS mapeados
      </h2>

      <hr className="my-6" />

      <Formik 
        onSubmit={(e) => {
          submitHandler(getFormValues(e));
        }} 
        validationSchema={validation}
        initialValues={{}}
        key={hook}
        innerRef={formikRef}
      >
        {({ errors, touched, setFieldValue, setFieldTouched, isSubmitting, values }) => (
          <Form>
            <p className="font-bold text-left">Deseja atualizar o volume:</p>

            {initialValues?.list?.map(e => {
              return (
                <div className="grid grid-cols-4 gap-x-4 my-4">
                  <div className="max-w-[200px]">
                    <InputField
                      labelName="Grupo de Produto:"
                      inputName={`grupoProduto-${e.id}`}
                      inputMask="offmask"
                      inputType="text"
                      defaultValue={e.grupoProduto}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      isDisabled={true}
                      isRequired={false}
                    />
                  </div>

                  <div className="max-w-[200px]">
                    <InputField
                      labelName="Etapa:"
                      inputName={`etapa-${e.id}`}
                      inputMask="offmask"
                      inputType="text"
                      defaultValue={e.etapa}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      isDisabled={true}
                      isRequired={false}
                    />
                  </div>

                  <div className="max-w-[200px]">
                    <InputField
                      labelName="Volume dos SKUS:"
                      inputName={`volume-${e.id}`}
                      inputMask="offmask"
                      inputType="text"
                      defaultValue={e.volume}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      isDisabled={true}
                      isRequired={false}
                    />
                  </div>

                  <div className="max-w-[150px]">
                    <InputField
                      labelName="Volume Total:"
                      inputName={`volumeTotal-${e.id}`}
                      inputMask="offmask"
                      inputType="number"
                      defaultValue={e.volumeTotal}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      isDisabled={false}
                      isRequired={true}
                    />
                  </div>
                </div>
              )
            })}

            <div className="text-left">
              <p className="font-bold text-left">Ou justifique a diferença:</p>
              <Select
                labelName="Justificativa:"
                defaultValue={initialValues?.single?.funilObraJustificativaId}
                inputName="funilObraJustificativaId"
                options={[
                  { label: "Nenhuma", value: "" },
                  ...(funilObraJustificativa?.optionFunilObraJustificativas || [])
                ]}
                onChange={(e) => {
                  if(e.value === "") funilObraJustificativa?.onChangeFunilObraJustificativa(e.value);

                  funilObraJustificativa?.SetSelectFunilObraJustificativa(e.value);
                  formikRef.current.setFieldValue('funilObraJustificativaId', e.value);
                  setTimeout(() => formikRef.current.setFieldTouched('funilObraJustificativaId', true));
                }}
                {...funilObraJustificativa?.funilObraJustificativaSelect}
              />
            </div>

            {errors.volumeValidacao && (
              <p
                className="text-[14px] text-[#ff0000] mt-2"
                dangerouslySetInnerHTML={{
                  __html: errors.volumeValidacao.replace(/\n/g, "<br />"),
                }}
              />
            )}
            <button type="submit" className="block bg-secundaria text-primaria px-8 py-3 rounded font-bold ml-auto">
              OK
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FunnelVolumeUpdateModal;
